var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldHomeHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 16.88c1.15 0 2.09-.94 2.09-2.09v-.7H12.7v2.79h.7zM10.6 16.88h.7v-2.79H8.51v.7c0 1.15.94 2.09 2.09 2.09zM8.51 12.7h2.79V9.91h-.7c-1.15 0-2.09.94-2.09 2.09v.7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 2.792c-1.57-1.1-3.97-1.04-5.48.13l-5.01 3.91C2.78 7.612 2 9.212 2 10.472v6.9c0 2.55 2.07 4.63 4.61 4.63h10.77a4.62 4.62 0 0 0 4.61-4.62v-6.78c.01-1.35-.86-3.01-1.96-3.78l-5.75-4.03zm-.89 15.49H10.6c-1.92 0-3.49-1.56-3.49-3.49v-2.79a3.5 3.5 0 0 1 3.49-3.49h2.79c1.92 0 3.49 1.56 3.49 3.49v2.79a3.5 3.5 0 0 1-3.49 3.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 9.91v2.79h2.79V12c0-1.15-.94-2.09-2.09-2.09h-.7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHomeHashtag);
export default __webpack_public_path__ + "static/media/vuesax-bold-home-hashtag.e01fcfb1d638b8788933ffac4794e40f.svg";
export { ForwardRef as ReactComponent };